import { Briefcase, MapPin } from 'lucide-react';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { CAREERS, CONTACT } from '../../content/site-pages';

export function CareersPage() {
  return (
    <StaticPageLayout
      title="Careers"
      subtitle="Join us in reimagining local fashion delivery"
    >
      <Card>
        <CardContent className="p-5">
          <p className="text-sm text-body leading-relaxed">
            We are a small team building same-day boutique delivery in New York City.
            Fash connects independent retailers with shoppers who want curated fashion
            without the wait — and we are just getting started.
          </p>
        </CardContent>
      </Card>

      <div>
        <h2 className="text-sm font-medium text-body uppercase tracking-wider mb-3 px-1">
          Open roles
        </h2>
        <div className="space-y-3">
          {CAREERS.map((role) => (
            <Card key={role.title}>
              <CardContent className="p-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Briefcase className="h-5 w-5 text-primary" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-medium text-heading">{role.title}</h3>
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-xs text-body">
                      <span className="inline-flex items-center gap-1">
                        <MapPin className="h-3.5 w-3.5" />
                        {role.location}
                      </span>
                      <span>{role.type}</span>
                    </div>
                    <p className="text-sm text-body mt-3 leading-relaxed">{role.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      <Card>
        <CardContent className="p-5 text-center space-y-2">
          <p className="text-sm text-body">
            Don&apos;t see the right role? We&apos;d still love to hear from you.
          </p>
          <a
            href={`mailto:${CONTACT.careersEmail}?subject=${encodeURIComponent('General application')}`}
            className="text-sm font-medium text-primary hover:underline"
          >
            Send your resume to {CONTACT.careersEmail}
          </a>
        </CardContent>
      </Card>
    </StaticPageLayout>
  );
}
